import { trackEvent } from '@/utils/analytics/trackEvent';

/**
 * Fire a quiz analytics event (server-side trackEvent). Callers are
 * responsible for gating this on `!isPreview` — preview traffic (the editor
 * "Preview" tab, or the editor's own PhonePreview canvas, WEB-848) must never
 * inflate telemetry. Also used directly by PublicQuizPage for the top-level
 * QUIZ_VIEW event (fired before the wizard mounts).
 *
 * WEB-848: extracted from PublicQuiz.tsx (behavior-preserving move) — mirrors
 * the paywall player's `paywall-runtime/trackPaywallEvent.ts` (WEB-662 atom 1).
 */
export function trackQuizEvent(
  projectId: string,
  quizSlug: string,
  event: string,
  payload: Record<string, unknown> = {},
) {
  trackEvent(
    { kind: 'quiz', projectId, slug: quizSlug },
    event,
    payload,
  );
}
